import {
  Button,
  Col,
  DatePicker,
  Form,
  Input,
  message,
  Radio,
  Row,
  Select,
  Upload,
  Image,
} from 'antd';

import TextArea from 'antd/lib/input/TextArea';
import dayjs, { Dayjs } from 'dayjs';
import React, { useEffect, useMemo, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '../../../redux/store';
import { JiraFormItemType, jiraTypeOptions } from '../../ProblemForm/constant';
import { PlusOutlined } from '@ant-design/icons';
import '../index.scss';
import { LoginState } from '../../../redux/type';
import { formatSelectOptions, isEmpty } from '@/utils';
import { colFormItem2, getBase64, jiraFormConfig } from '../constant';
import { formatJiraSubmit } from '../../Keys/utils/format';
import { api } from '../../../fetch/bussiness/api';
import { HttpStatusCode } from '../../../fetch/core/constant';
import qs from 'qs';
import './index.scss';
import { JIRA_SOURCE } from '../../../utils/constant';
import { getRoverVersionList } from '@/components/ProblemForm/OptimizeJira';
import { cloneDeep, debounce } from 'lodash';
import { request } from '@/fetch/core';
import {
  addGlobalEventListener,
  removeGlobalEventListener,
} from '@/utils/emit';
import UseGetCommonEnumMap from '@/utils/hooks/UseGetCommonEnumMap';
import { CommonEnumKey } from '@/utils/enum';

const layout = {
  labelCol: { span: 8 },
  wrapperCol: { span: 16 },
};
interface Props {
  form: any;
  selectIssueAlarm?: string; // 选中工单报警后，进行提报。
  closePopoverModel?: any;
  openJiraModal?: boolean; // 事故排查-提报jira
  selectAccident?: any; // 从单车页右下角事故排查tab的卡片处点击提报缺陷，带入的事故信息
  showFooter?: boolean;
  submitJira?: boolean;
  vehicleName?: string;
}

const severityList = formatSelectOptions(
  localStorage.getItem('ENUM_LIST_MAP') &&
    JSON.parse(localStorage.getItem('ENUM_LIST_MAP') || '{}')[
      'BUG_SEVERITY_ENUM'
    ]
);
const JiraForm = (props: Props) => {
  const { selectAccident, showFooter, form, submitJira } = props;
  const singleVehiclePageInfo = useSelector(
    (state: RootState) => state.singleVehiclePageInfo
  );
  const login = useSelector((state: RootState) => state.login);
  const { vehicleBasicInfoNew } = singleVehiclePageInfo;
  const { vehicleVersion } = vehicleBasicInfoNew;
  const [versionList, setVersionList] = useState<any>([]);
  const customValidatorRef = useRef<any>([]);
  const submitLockRef = useRef(false);
  const onFinishRef = useRef<(() => Promise<void>) | null>(null);
  const submitWithLockRef = useRef<(() => void) | null>(null);
  const [jiraFormData, setJiraFormData] = useState<any>([]);
  const jiraFormRef = useRef<any>(cloneDeep(jiraFormConfig));
  const query = qs.parse(window.location.search.split('?')[1]);
  const vehicleName = (query && query.license) || props.vehicleName;
  const [occurTime, setOccurTime] = useState<Dayjs | null>(
    selectAccident ? dayjs(selectAccident.accidentTime) : dayjs()
  );
  const [loading, setLoading] = useState(false);
  const [issueFormInit, setIssueFormInit] = useState<any>({
    topic: null,
    description: null,
  });
  const [upLoadState, setUpLoadState] = useState<any>({
    previewVisible: false,
    previewImage: '',
    previewTitle: '',
    fileList: [],
  });
  const formHeight = '420px';
  const { enumMap } = UseGetCommonEnumMap([
    CommonEnumKey.NEW_ACCIDENT_LEVEL_ENUM,
    CommonEnumKey.THOROUGH_ACCIDENT_TYPE_ENUM,
    CommonEnumKey.BUG_SEVERITY_ENUM,
    CommonEnumKey.ACCIDENT_RESPONSIBLE_ENUM,
  ]);

  useEffect(() => {
    jiraFormRef.current?.data?.forEach((item: any) => {
      jiraFormRef.current?.linkRules?.forEach((rules: any) => {
        if (item.name === rules.linkFieldName) {
          customValidatorRef.current.push({
            name: item.name,
            rules: item.rules,
          });
        }
      });
    });
    jiraFormConfig?.data?.forEach((item: any) => {
      jiraFormConfig?.linkRules?.forEach((rules: any) => {
        if (item.name === rules.linkFieldName) {
          customValidatorRef.current.push({
            name: item.name,
            rules: item.rules,
          });
        }
      });
    });
    const formatData = formatFormData(cloneDeep(jiraFormRef.current));

    // 当从单车页右侧“事故排查”tab点进「提报缺陷」时，需要设置一些“数据回显”和“字段展示”的逻辑
    if (props?.openJiraModal) {
      // 默认的数据回显
      const topic = ' ';
      const initdata = {
        topic,
        technicalSupportResponsible: props.selectAccident?.responsible || null, // 单车页右下角事故排查的卡片的有无责任字段，可自动带入
        accidentLevel: props.selectAccident?.accidentLevel || null, // 单车页右下角事故排查的卡片的事故等级字段，可自动带入
        version: vehicleVersion || null,
        severity: (severityList && severityList[1]) || null,
        debugTime: occurTime,
        isCrash: '1',
        follower: '',
      };
      form.setFieldsValue(initdata);
      // 将表单配置的特定字段恢复显示（默认关闭‘是否为碰撞/剐蹭’字段，其他四个事故字段需要显示）
      formatData.data.forEach((item: any) => {
        if (
          item.name == 'accidentLevel' ||
          item.name == 'accidentType' ||
          item.name == 'follower' ||
          item.name === 'technicalSupportResponsible'
        ) {
          item.hidden = false;
          item.rules = true;
        } else if (item.name == 'isCrash') {
          item.hidden = true;
        }
      });
    } else {
      const initialValues = {
        severity: (severityList && severityList[2]) || null,
        version: vehicleVersion || null,
        debugTime: occurTime,
        isCrash: '0',
        follower: '',
      };
      form.setFieldsValue(initialValues);
    }
    setJiraFormData(formatData);
    if (login.state === LoginState.LOGINED) {
      getRoverVersionList().then((res) => {
        if (res.code === HttpStatusCode.Success) {
          if (!isEmpty(res.data)) {
            setVersionList(
              res.data.map((item: string) => {
                return {
                  label: item,
                  value: item,
                };
              })
            );
          }
        }
      });
    }
    return () => {
      form.setFieldsValue({
        topic: '',
        description: '',
        accidentLevel: '',
        accidentType: '',
      });
      setIssueFormInit({
        topic: null,
        description: null,
        accidentLevel: '',
        accidentType: '',
      });
    };
  }, []);

  useEffect(() => {
    if (submitJira) {
      onFinish();
      submitJira;
    }
  }, [submitJira]);

  const formatFormData = (formData: any) => {
    return {
      ...formData,
      data: formData?.data?.map((item: any) => {
        if (item.hidden) {
          return {
            ...item,
            rules: false,
          };
        }
        return item;
      }),
    };
  };
  const onFieldsChange = (changedValues: any, allValues: any) => {
    const changedValue = changedValues[0];
    const changedName = changedValue?.name[0];
    // Iterate through the link rules in the form data
    for (const i of jiraFormData?.linkRules || []) {
      if (i.fieldName === changedName) {
        const { linkFieldName, type, visibleRule } = i;

        if (type.includes('visible') && visibleRule) {
          const { show } = visibleRule;

          // Find the link field in the form data
          const linkField = jiraFormData.data.find(
            (field: any) => field.name === linkFieldName
          );
          // Update the visibility of the link field
          linkField.hidden = !show.includes(changedValue.value);
          // Update the required validation rule of the link field
          customValidatorRef.current.forEach((item: any) => {
            if (linkField.name === item.name && !linkField.hidden) {
              linkField.rules = cloneDeep(item.rules);
            } else if (linkField.name === item.name && linkField.hidden) {
              if (linkField?.rules) {
                linkField.rules = false;
              }
            }
          });
        }
      }
    }
    // Update the form data
    setJiraFormData({ ...jiraFormData });
  };
  const getMatchVersionId = (
    versionList: { value: string; label: string }[],
    vehicleVersion: string
  ) => {
    const reg = /_engine$/g;
    let selectId: string | number | undefined | null = null;
    const arr = reg.exec(vehicleVersion);
    if (arr !== null) {
      selectId = versionList.find(
        (item) =>
          item.label === vehicleVersion.substring(0, arr?.index) ||
          item.label === vehicleVersion
      )?.value;
    } else if (arr === null) {
      selectId = versionList.find(
        (item) => item.label === vehicleVersion
      )?.value;
    }
    return selectId ? String(selectId) : null;
  };
  const changeTime = (value: Dayjs | null) => {
    if (!value) {
      form.setFieldsValue({ debugTime: null });
      setOccurTime(null);
      return;
    }
    form.setFieldsValue({ debugTime: value });
    setOccurTime(value);
  };
  // 图片上传
  const uploadChange = ({ file, fileList }: any) => {
    const newFileList: any[] = fileList.map((item: any) => {
      return file.uid == item.uid
        ? { ...item, uidName: `${item.uid}${item.name}` }
        : item;
    });
    const fileData = { ...upLoadState, fileList: newFileList };
    setUpLoadState(fileData);
    form?.setFieldValue('attachment', fileData);
  };
  /**
   * 上传附件
   * @param {any} option
   */
  const customRequest = (option: any) => {
    const reader = new FileReader();
    reader.readAsDataURL(option.file);
    reader.onloadend = function (e: any) {
      option.onSuccess();
    };
  };

  const handlePreview = async (file: any) => {
    if (!file.preview) {
      file.preview = await getBase64(file.originFileObj);
    }
    const imgCurrentIndex = upLoadState.fileList.findIndex((item: any) => {
      return item.uid == file.uid;
    });
    setUpLoadState({
      ...upLoadState,
      previewImage: file.preview,
      previewVisible: true,
      previewTitle:
        file.name || file.url.substring(file.url.lastIndexOf('/') + 1),
      imgCurrentIndex: imgCurrentIndex,
    });
  };
  const toFormData = (data: any) => {
    if (data === null) return null;
    return Object.keys(data).reduce((formData, item) => {
      if (item === 'attachment') {
        // 特殊判断如果内容为files数组，就直接append
        data[item] &&
          data[item].forEach((curr: any) => {
            formData.append('attachment', curr);
          });
      } else if (item === 'debugTime') {
        data[item] && formData.append('debugTime', data[item]);
      } else {
        formData.append(item, data[item]);
      }
      return formData;
    }, new FormData());
  };
  /**
   * 提报jira
   * @param {any} values form表单参数
   */
  const onFinish = async () => {
    setLoading(true);
    try {
      const values = await form.validateFields();
      const { attachment, ...other } = values;
      const concatValues = {
        ...values,
        debugTime: values.debugTime
          ? dayjs(values.debugTime).format('YYYY-MM-DD HH:mm:ss')
          : values.debugTime,
        attachment: attachment?.fileList?.map((item: any) => {
          return item.originFileObj;
        }),
      };
      const param = formatJiraSubmit(concatValues, vehicleName);
      const requestBody = {
        ...param,
        issueNo: props?.selectAccident
          ? props?.selectAccident.accidentNo
          : null,
        jiraSource: props?.selectAccident
          ? JIRA_SOURCE.ACCIDENT
          : JIRA_SOURCE.ISSUE,
      };
      const submitData: RequestOptions = {
        method: 'POST',
        absoluteURL:
          location.protocol +
          '//' +
          process.env.JDX_APP_FETCH_DATA_DOMAIN +
          api.submitJira,
        contentType: 'formData',
        body: toFormData(requestBody),
      };
      const resp = await request(submitData);
      if (resp.code == HttpStatusCode.Success) {
        message.success('提报成功');
        props.closePopoverModel && props.closePopoverModel();
      } else {
        message.error(resp.message);
      }
    } catch (e) {
    } finally {
      setLoading(false);
    }
  };

  onFinishRef.current = onFinish;
  submitWithLockRef.current = async () => {
    if (submitLockRef.current) return;
    submitLockRef.current = true;
    try {
      await onFinishRef.current?.();
    } finally {
      submitLockRef.current = false;
    }
  };

  const onFinishDebounced = useMemo(
    () =>
      debounce(
        () => {
          submitWithLockRef.current?.();
        },
        1500,
        { leading: true, trailing: false }
      ),
    []
  );

  useEffect(() => {
    return () => {
      onFinishDebounced.cancel();
    };
  }, [onFinishDebounced]);

  useEffect(() => {
    addGlobalEventListener('JIRA_SUBMIT', onFinish);
    return () => {
      removeGlobalEventListener('JIRA_SUBMIT', onFinish);
    };
  }, []);
  const itemNode = (item: JiraFormItemType) => {
    const { label, name, rules, rulesMessage, itemType } = item;
    const optionsMap = new Map([
      ['isCrash', jiraTypeOptions],
      [
        'technicalSupportResponsible',
        enumMap[CommonEnumKey.ACCIDENT_RESPONSIBLE_ENUM],
      ],
      ['accidentLevel', enumMap[CommonEnumKey.NEW_ACCIDENT_LEVEL_ENUM]],
      ['accidentType', enumMap[CommonEnumKey.THOROUGH_ACCIDENT_TYPE_ENUM]],
      ['severity', enumMap[CommonEnumKey.BUG_SEVERITY_ENUM]],
      ['version', versionList],
    ]);
    let formNode = <></>;
    switch (itemType) {
      case 'radio':
        formNode = (
          <div className="re-radio">
            <Radio.Group
              options={optionsMap.get(name)}
              name={name}
              defaultValue={props?.openJiraModal ? '1' : '0'}
            ></Radio.Group>
          </div>
        );
        break;
      case 'input':
        formNode = (
          <Input
            placeholder={item.placeholder}
            maxLength={item.maxLength || 30}
          />
        );
        break;
      case 'textArea':
        formNode = (
          <TextArea placeholder={item.placeholder} rows={3} maxLength={500} />
        );
        break;
      case 'select':
        formNode = (
          <Select
            placeholder={item && item.placeholder}
            filterOption={item.name === 'componentId'}
            options={optionsMap.get(name)}
          />
        );
        break;
      case 'custom':
        formNode = (
          <div className="re-picker">
              <DatePicker
                showTime
                onChange={changeTime}
                value={occurTime}
                inputReadOnly={true}
                className="single-picker"
                allowClear={false}
                format="YYYY-MM-DD HH:mm:ss"
              />
          </div>
        );
        break;
      case 'upload':
        formNode = (
          <div className="upload-box">
            <Upload
              // action="https://www.mocky.io/v2/5cc8019d300000980a055e76"
              listType="picture-card"
              fileList={upLoadState.fileList}
              onPreview={handlePreview}
              onChange={uploadChange}
              customRequest={customRequest}
            >
              {upLoadState.fileList.length >= 3 ? null : (
                <div>
                  {' '}
                  <PlusOutlined />
                </div>
              )}
            </Upload>
            {upLoadState.previewImage && upLoadState.previewImage && (
              <Image
                wrapperStyle={{ display: 'none' }}
                preview={{
                  visible: upLoadState.previewVisible,
                  onVisibleChange: (visible) => {
                    const fileData = {
                      ...upLoadState,
                      previewVisible: visible,
                      previewImage: '',
                    };
                    setUpLoadState(fileData);
                    form?.setFieldValue('attachment', fileData);
                  },
                }}
                src={upLoadState.previewImage}
              />
            )}
          </div>
        );
        break;
      default:
        return <></>;
    }
    return formNode;
  };

  return (
    <div className="jira-submit-container">
      <div className="form-container">
        <Form
          {...layout}
          form={form}
          initialValues={issueFormInit}
          onFieldsChange={onFieldsChange}
        >
          <Row style={{ maxHeight: formHeight, overflowY: 'scroll' }}>
            <Col span={11}>
              {jiraFormData &&
                jiraFormData?.data?.map((item: JiraFormItemType) => {
                  return (
                    <Form.Item
                      label={item.label}
                      name={item.name}
                      rules={[
                        { required: item.rules, message: item.rulesMessage },
                      ]}
                      key={item.name}
                      hidden={!!item.hidden}
                    >
                      {itemNode(item)}
                    </Form.Item>
                  );
                })}
            </Col>
            <Col span={11}>
              {colFormItem2.map((item: JiraFormItemType) => {
                return (
                  <Form.Item
                    label={item.label}
                    name={item.name}
                    rules={[
                      { required: item.rules, message: item.rulesMessage },
                    ]}
                    key={item.name}
                  >
                    {itemNode(item)}
                  </Form.Item>
                );
              })}
            </Col>
          </Row>
          {showFooter || typeof showFooter === 'undefined' ? (
            <div className="deal-form-footer">
              <Button
                style={{ marginRight: 12 }}
                onClick={() => {
                  props.closePopoverModel && props.closePopoverModel();
                }}
              >
                取消
              </Button>
              <Button
                type="primary"
                onClick={onFinishDebounced}
                loading={loading}
              >
                提报
              </Button>
            </div>
          ) : (
            <></>
          )}
        </Form>
      </div>
    </div>
  );
};
export default React.memo(JiraForm);
